import { frontendURL } from 'dashboard/helper/URLHelper';
import KanbanView from './Index.vue';
import CrmReportsView from './CrmReportsView.vue';
import GeneralReportTab from './reports/GeneralReportTab.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const reportsPermissions = {
  permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_view',
    component: KanbanView,
    meta: reportsPermissions,
  },
  {
    path: frontendURL('accounts/:accountId/kanban/:funnelId'),
    name: 'kanban_funnel',
    component: KanbanView,
    meta: reportsPermissions,
  },
  {
    path: frontendURL('accounts/:accountId/crm/tasks'),
    name: 'kanban_tasks',
    component: () => import('./TasksView.vue'),
    meta: reportsPermissions,
  },
  {
    path: frontendURL('accounts/:accountId/crm/products'),
    name: 'kanban_products',
    component: () => import('./ProductsView.vue'),
    meta: reportsPermissions,
  },
  {
    path: frontendURL('accounts/:accountId/crm/reports'),
    component: CrmReportsView,
    meta: reportsPermissions,
    children: [
      {
        path: '',
        name: 'crm_reports',
        component: GeneralReportTab,
        meta: reportsPermissions,
      },
      {
        path: 'origem',
        name: 'crm_reports_origin',
        component: () => import('./reports/OriginReportTab.vue'),
        meta: reportsPermissions,
      },
      {
        path: 'plataforma',
        name: 'crm_reports_platform',
        component: () => import('./reports/PlatformReportTab.vue'),
        meta: reportsPermissions,
      },
      {
        path: 'anuncio',
        name: 'crm_reports_ad',
        component: () => import('./reports/AdReportTab.vue'),
        meta: reportsPermissions,
      },
      {
        path: 'painel',
        name: 'crm_reports_dashboard',
        component: () => import('./reports/DashboardTab.vue'),
        meta: reportsPermissions,
      },
      {
        path: 'personalizados',
        name: 'crm_reports_custom',
        component: () => import('./reports/CustomReportsTab.vue'),
        meta: reportsPermissions,
      },
    ],
  },
];
